import React from 'react'
import PropTypes from 'prop-types'

const PATH = 'M8.83333 11.5L7.04167 9.70834C6.88889 9.55556 6.69445 9.47917 6.45833 9.47917C6.22222 '
  + '9.47917 6.02778 9.55556 5.875 9.70834C5.72222 9.86112 5.64583 10.0556 5.64583 '
  + '10.2917C5.64583 10.5278 5.72222 10.7222 5.875 10.875L8.25 13.25C8.41667 13.4167 8.61111 13.5 '
  + '8.83333 13.5C9.05556 13.5 9.25 13.4167 9.41667 13.25L14.125 8.54167C14.2778 8.38889 14.3542 '
  + '8.19445 14.3542 7.95834C14.3542 7.72223 14.2778 7.52778 14.125 7.375C13.9722 7.22223 13.7778 '
  + '7.14584 13.5417 7.14584C13.3056 7.14584 13.1111 7.22223 12.9583 7.375L8.83333 11.5ZM10 '
  + '18.3333C8.84722 18.3333 7.76389 18.1146 6.75 17.6771C5.73611 17.2396 4.85417 16.6458 4.10417 '
  + '15.8958C3.35417 15.1458 2.76042 14.2639 2.32292 13.25C1.88542 12.2361 1.66667 11.1528 '
  + '1.66667 10C1.66667 8.84723 1.88542 7.76389 2.32292 6.75C2.76042 5.73612 3.35417 4.85417 '
  + '4.10417 4.10417C4.85417 3.35417 5.73611 2.76042 6.75 2.32292C7.76389 1.88542 8.84722 1.66667 '
  + '10 1.66667C11.1528 1.66667 12.2361 1.88542 13.25 2.32292C14.2639 2.76042 15.1458 3.35417 '
  + '15.8958 4.10417C16.6458 4.85417 17.2396 5.73612 17.6771 6.75C18.1146 7.76389 18.3333 8.84723 '
  + '18.3333 10C18.3333 11.1528 18.1146 12.2361 17.6771 13.25C17.2396 14.2639 16.6458 15.1458 '
  + '15.8958 15.8958C15.1458 16.6458 14.2639 17.2396 13.25 17.6771C12.2361 18.1146 11.1528 '
  + '18.3333 10 18.3333ZM10 16.6667C11.8611 16.6667 13.4375 16.0208 14.7292 14.7292C16.0208 '
  + '13.4375 16.6667 11.8611 16.6667 10C16.6667 8.13889 16.0208 6.5625 14.7292 5.27084C13.4375 '
  + '3.97917 11.8611 3.33334 10 3.33334C8.13889 3.33334 6.5625 3.97917 5.27083 5.27084C3.97917 '
  + '6.5625 3.33333 8.13889 3.33333 10C3.33333 11.8611 3.97917 13.4375 5.27083 14.7292C6.5625 '
  + '16.0208 8.13889 16.6667 10 16.6667Z'

const CircleCheckIcon = ({ className }) => (
  <svg className={className} fill="none" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <path d={PATH} fill="currentColor" />
  </svg>
)

CircleCheckIcon.propTypes = {
  className: PropTypes.string
}

CircleCheckIcon.defaultProps = {
  className: 'tw:h-4 tw:w-4'
}

export default CircleCheckIcon
